module.exports = __webpack_public_path__ + "img/BlarggsTestRom.1699a06f.png";